import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const useChannels = () => {
  const [data, setData] = useState([]);
  const [dataMap, setDataMap] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get("/saas/shop/channels", {
        params: {}
      });
      let newDataMap = {};
      data2?.map((cData) => {
        newDataMap[cData.id] = cData;
      });
      setData(data2);
      setDataMap(newDataMap);
      return data2;
    } catch (error) {
      handleError(error);
      return [];
    } finally {
      setLoading(false);
    }
  };
  return {
    channelsLoading: loading,
    channels: data,
    channelMap: dataMap,
    fetchChannels: fetchData
  };
};
export const useChannelsModel = createModel(useChannels);
export const useChannelCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (channelId) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/shop/get-categories`, {
        channel: channelId
      });
      const handleData = (data3) => {
        for (let i = 0; i < data3.length; i++) {
          if (Array.isArray(data3[i].children) && data3[i].children.length === 0) {
            data3[i].children = null;
          } else {
            handleData(data3[i].children);
          }
        }
        return data3;
      };
      handleData(data2);
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    channelCategoriesLoading: loading,
    channelCategories: data,
    fetchChannelCategories: fetchData
  };
};
export const useChannelCategoriesModel = createModel(useChannelCategories);
export const useChannelShopCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get(`/saas/product-category/channels/get-categories-by-shop`, {
        params
      });
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    channelShopCategoriesLoading: loading,
    channelShopCategories: data,
    fetchChannelShopCategories: fetchData
  };
};
export const useChannelShopCategoriesModel = createModel(useChannelShopCategories);
